import { useLocation } from 'quartz-routing/react-router';
import { useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { ACRouterButton } from 'academy-common-lib/components/ACRouterButton';
import UsageTracker from '../../../utils/UsageTracker';
import { VIDEO_TIMESTAMP_PARAM } from '../../../features/video/videoConstants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const FullWidthHighlight = styled.div.withConfig({
  displayName: "LessonNavigatorAsset__FullWidthHighlight"
})(["position:relative;z-index:1;cursor:pointer;user-select:none;a:hover{text-decoration:none;}&::before{cursor:pointer;content:'';display:block;position:absolute;top:0;left:0;width:200vw;height:100%;transform:translateX(-50vw);z-index:-1;background-color:", ";}&:hover h6,&:hover p{color:", ";}"], ({
  theme,
  isActive
}) => isActive ? theme.color['fill-surface-recessed-pressed'] : 'transparent', ({
  theme
}) => theme.color['text-interactive-default-hover']);
const DisableLinkTextDecoration = styled.div.withConfig({
  displayName: "LessonNavigatorAsset__DisableLinkTextDecoration"
})(["a:hover{text-decoration:none;}"]);
const LessonNavigatorAsset = ({
  active = false,
  showFocus = false,
  courseId,
  id,
  helpText,
  lessonId,
  title
}) => {
  const location = useLocation();
  const search = useMemo(() => {
    const params = new URLSearchParams(location.search);
    params.delete(VIDEO_TIMESTAMP_PARAM);
    const result = params.toString();
    return result ? `?${result}` : '';
  }, [location.search]);
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(DisableLinkTextDecoration, {
      children: /*#__PURE__*/_jsx(ACRouterButton, {
        "data-test-id": "lesson-navigator-asset-link",
        onClick: () => {
          UsageTracker.trackStandalone('Learning Center Interaction', {
            action: 'lesson-navigator-asset-click',
            pathname: location.pathname,
            contentId: id,
            lessonId,
            trackId: courseId,
            title
          });
        },
        to: Object.assign({}, location, {
          pathname: courseId ? `/tracks/${courseId}/${lessonId}/${id}` : `/lessons/${lessonId}/${id}`,
          search
        }),
        use: "unstyled",
        children: /*#__PURE__*/_jsx(FullWidthHighlight, {
          "data-test-id": `lesson-navigator-asset-${id}`,
          isActive: active,
          children: /*#__PURE__*/_jsxs(View, {
            paddingBlock: "200",
            textAlign: "start",
            children: [showFocus && /*#__PURE__*/_jsx(Badge, {
              marginBlockEnd: "200",
              use: "pantera",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "academyCommon.lessonNavigator.focusRibbon"
              })
            }), /*#__PURE__*/_jsx(Text, {
              as: "h6",
              children: title
            }), helpText && /*#__PURE__*/_jsx(Text, {
              as: "p",
              children: helpText
            })]
          })
        })
      })
    })
  );
};
export default LessonNavigatorAsset;